import { Link } from 'react-router-dom';
import './ChevronLink.css';
import { ReactNode } from 'react';

type Props = {
    chevronDirection: 'left' | 'right' | 'up' | 'down' | 'left-down' | 'left-up';
    text?: string;
    children?: ReactNode;
    linkUrl?: string;
    linkDisabled?: boolean;
    onClick?: () => void;
    className?: string;
};

const ChevronLink = ({
    chevronDirection,
    text,
    children,
    linkUrl,
    linkDisabled = false,
    onClick,
    className
}: Props) => {
    const isHorizontalDirection = chevronDirection === 'left' || chevronDirection === 'right';
    const isExternalLink = linkUrl?.startsWith('http') || linkUrl?.startsWith('mailto') || linkUrl?.startsWith('tel');
    const Wrapper = linkDisabled ? 'div' : isExternalLink ? 'a' : Link;

    return (
        <Wrapper
            {...(isExternalLink ? { href: linkUrl } : { to: linkUrl ?? '' })}
            className={`chevronLink chevronLink-${chevronDirection} ${className || ''}`}
            onClick={onClick}
            target={isExternalLink ? '_blank' : ''}
        >
            {text || children}
            <span className='material-symbols-rounded'>
                {isHorizontalDirection ? 'chevron_right' : 'keyboard_arrow_up'}
            </span>
        </Wrapper>
    );
};

export default ChevronLink;
